import React from "react";
import { useDrop } from "react-dnd";
import { makeStyles } from "@material-ui/core/styles";
const ItemType = "marker";

const useStyles = makeStyles((_) => ({
  dropContainer: {
    width: "100%",
    height: "100%",
    maxWidth: "500px",
    marginInline: "auto",
    position: "relative",
  },
}));

const DropContainer = ({ children, addMarker, moveMarker }) => {
  const classes = useStyles();
  const [, drop] = useDrop(() => ({
    accept: ItemType,
    drop: (item, monitor) => {
      const delta = monitor.getDifferenceFromInitialOffset();
      const left = Math.round(item.x + delta.x);
      const top = Math.round(item.y + delta.y);
      moveMarker(item.id, left, top);
      return undefined;
    },
  }));

  const handleOnClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    addMarker({ x, y });
  };

  return (
    <div ref={drop} onClick={handleOnClick} className={classes.dropContainer}>
      {children}
    </div>
  );
};
export default DropContainer;
